import { useGetOGPUserInfo } from 'ogp/hooks';
import { hasAccessWithinPolicyGroup, PolicyGroups } from 'shared/utils/policy-controller';
import { BranchOfficeRole } from 'types/roles/BranchOfficeRole';

export const useHasBranchOfficeRole = (role: BranchOfficeRole) => {
  const userQuery = useGetOGPUserInfo();
  const hasRole =
    userQuery.data &&
    hasAccessWithinPolicyGroup(PolicyGroups.DEPARTMENT, userQuery.data.userInfo, role);
  return hasRole ?? false;
};
